// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"09b8e6ad","607":"2fb2ce41","644":"fbdf4103","667":"274d7829","840":"58b69fd6"}[chunkId] + ".chunk.js";
};